// @flow

import memoize from 'memoize-weak';
import { chunk, identity, toPairs } from 'lodash';

type Props = { [string]: any };
type PropPairs = Array<any>;
type ObjectFactory = Props => Props;

// DO NOT USE only exported for testing purposes
export const flattenProps = (props: Props): PropPairs =>
  toPairs(props).reduce((flattened, pair) => [...flattened, ...pair], []);

// DO NOT USE only exported for testing purposes
export const reifyProps = (propPairs: PropPairs): Props =>
  chunk(propPairs, 2).reduce(
    (props, pair) => ({
      ...props,
      [pair[0]]: pair[1],
    }),
    {}
  );

type Options = {
  debug?: boolean,
};

// Create a cache which keys objects based on
// the shallow references of their key/value pairs
const objectCache = (
  fn: ObjectFactory = identity,
  options: Options = { debug: false }
) => {
  const memoizedFn = memoize((...propPairs: PropPairs) =>
    fn(reifyProps(propPairs))
  );

  return (props: Props) => {
    if (options.debug) console.info(props);
    const args = flattenProps(props);
    return memoizedFn(...args);
  };
};

export default objectCache;
